import type { Reply } from '@shared/types/frontend/ubff/hotel-reviews';
import type { I18nService } from '@shared/types/i18n';
import type {
  Filter,
  FilterType,
  FilterOption,
  FilterGroup,
} from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/hotelreview/v1/hotel_review.pb';

export const buildImageAltText = ({
  i18n,
  imageIndex,
  reviewIndex,
}: {
  imageIndex: number;
  i18n: I18nService;
  reviewIndex?: number;
}) => {
  const imageInReview = typeof reviewIndex === 'number';
  const imageIndexNum = imageIndex + 1;
  return imageInReview
    ? i18n.translate('ktxtHotelDetail_review_image_button_aria_label', {
        review_index: reviewIndex + 1,
        image_index: imageIndexNum,
      })
    : i18n.translate('ktxtHotelDetail_review_image_a11y_alt', {
        index: imageIndexNum,
      });
};

export const SORT_FILTER_KEY = 'sort_by';
export const TAG_FILTER_TYPE = 'FILTER_TYPE_TAG';

export const getSelectedFilterItem = ({
  displayText,
  filterOptions,
  filterType,
  selectedFilters,
}: {
  selectedFilters?: Filter[];
  filterOptions: FilterOption[];
  displayText: string;
  filterType: FilterType;
}) => {
  let showText = displayText;
  let selected = false;

  if (selectedFilters?.length && filterOptions?.length) {
    const selectedFilterItem = selectedFilters.find(
      ({ type: selectedFilterType }) => selectedFilterType === filterType,
    );
    const selectedOption = filterOptions.find(
      ({ value }) => value === selectedFilterItem?.value && value !== 'all',
    );

    showText = selectedOption?.displayText || displayText;
    selected = Boolean(selectedOption);
  }

  return { displayText: showText, selected };
};

export const getFilterGroupByType = ({
  filterGroups,
  tagType,
}: {
  filterGroups?: FilterGroup[];
  tagType: boolean;
}) => {
  const availableFilters = filterGroups && filterGroups.length > 0;
  if (!availableFilters) {
    return [];
  }

  return filterGroups.filter(({ type }) =>
    tagType ? type === TAG_FILTER_TYPE : type !== TAG_FILTER_TYPE,
  );
};

export const getSourceLocale = ({
  replies,
  reviewLocale,
  userLocale,
}: {
  userLocale: string;
  reviewLocale: string;
  replies?: Reply[];
}): string => {
  if (reviewLocale !== userLocale) return reviewLocale;
  const fallback = replies?.find(
    (r) => r.locale && r.locale !== userLocale,
  )?.locale;
  return fallback ?? reviewLocale;
};

export const REVIEWS_PER_PAGE_DESKTOP = 5;
export const REVIEWS_PER_PAGE_MOBILE = 10;
